import * as moment from "moment";
import {InvoiceEventApiDto, InvoiceSentEventDataApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import InvoiceEvent, {InvoiceEventTypeEnum} from "./InvoiceEvent";
import {option, Option} from "ts-option";

/**
 * Invoice sent event model.
 */
export default class InvoiceSentEvent extends InvoiceEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {InvoiceEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} creator entity which created the event.
	 * @param {moment.Moment} creationDateTime creation date of event.
	 * @param {InvoiceSentEventData} data draft invoice created event data.
	 */
	constructor(public readonly id: string,
		public readonly type: InvoiceEventTypeEnum,
		public readonly creator: AuthenticatedEntity,
		public readonly creationDateTime: moment.Moment,
		public readonly data: InvoiceSentEventData) {
		super(id, type, creator, creationDateTime);
	}

	public static fromJson(json: InvoiceEventApiDto): InvoiceSentEvent {
		const data = InvoiceSentEventData.fromJson(json.data as InvoiceSentEventDataApiDto);
		const creator = AuthenticatedEntity.fromJson(json.creator);
		return new InvoiceSentEvent(json.id, InvoiceEventTypeEnum.InvoiceSent, creator,
			moment(json.creationDateTime), data);
	}

	getIcon() {
		return Icon.New;
	}

	getActivityType(): string {
		return `INVOICE SENT`;
	}

	getActivityMessage(): string {
		return `Invoice has been sent`
	}
}

export class InvoiceSentEventData {
	constructor(public readonly jobId: string,
		public readonly quoteId: string,
		public readonly invoiceNo: string,
		public readonly customerId: string,
		public readonly referenceNumber: string,
		public readonly emailHtml: Option<string>) {}

	public static fromJson(json: InvoiceSentEventDataApiDto): InvoiceSentEventData {
		return new InvoiceSentEventData(json.jobId, json.quoteId, json.invoiceNo, json.customerId, json.referenceNumber,
			option(json.emailHtml));
	}
}
